import FJAppConstant from '../../constants/FJAppConstant.js';
import FJImageManipulationConfig from '../../config/appConfig/FJImageManipulationConfig.js';
import FJFaceSwapConfig from '../../config/appConfig/FJFaceSwapConfig.js';
import FJTextToImageConfig from '../../config/appConfig/FJTextToImageConfig.js';
import FJImageEnhancerConfig from '../../config/appConfig/FJImageEnhancerConfig.js';
import FJImageToImageConfig from '../../config/appConfig/FJImageToImageConfig.js';
import FJClothesChangerConfig from '../../config/appConfig/FJClothesChangerConfig.js';
import FJImageExtenderConfig from '../../config/appConfig/FJImageExtenderConfig.js';
import FJFake3dConfig from '../../config/appConfig/FJFake3dConfig.js';
import FJObjectEraseConfig from '../../config/appConfig/FJObjectEraseConfig.js';
import FJPhotoRemoveBgConfig from '../../config/appConfig/FJPhotoRemoveBgConfig.js';
import FJAIVideoGeneratorConfig from '../../config/appConfig/FJAIVideoGeneratorConfig.js';
import FJAIAudioConfig from '../../config/appConfig/FJAIAudioConfig.js';
import FJVideoRemoveBgConfig from '../../config/appConfig/FJVideoRemoveBgConfig.js';
import FJTextBasedEditingConfig from '../../config/appConfig/FJTextBasedEditingConfig.js';
import FJAppConfig from './FJAppConfig.js';
import FJAiVideoDubConfig from '../../config/appConfig/FJAiVideoDubConfig.js';
import FJTextToVideoConfig from '../../config/appConfig/FJTextToVideoConfig.js';

const currentProjectType = import.meta.env.VITE_CURRENT_PROJECT_TYPE; // 当前项目

const FJAppConfigList = [
    { urlKey: 'old-photo-restoration', type: FJAppConstant.PHOTO_RESTORATION, config: FJImageManipulationConfig },
    { urlKey: 'face-swap', type: FJAppConstant.FACE_SWAP, config: FJFaceSwapConfig },
    { urlKey: 'photo-colorizer', type: FJAppConstant.PHOTO_COLORIZE, config: FJImageManipulationConfig },
    { urlKey: 'text-to-image', type: FJAppConstant.TEXT_TO_IMAGE, config: FJTextToImageConfig },
    { urlKey: 'image-upscaler', type: FJAppConstant.IMAGE_ENHANCER, config: FJImageEnhancerConfig },
    { urlKey: 'image-to-image', type: FJAppConstant.IMAGE_TO_IMAGE, config: FJImageToImageConfig },
    { urlKey: 'clothes-changer', type: FJAppConstant.CLOTHES_CHANGER, config: FJClothesChangerConfig },
    { urlKey: 'image-extender', type: FJAppConstant.IMAGE_EXTENDER, config: FJImageExtenderConfig },
    { urlKey: '3d-photo-animation', type: FJAppConstant.FAKE_3D, config: FJFake3dConfig },
    { urlKey: 'object-remover', type: FJAppConstant.OBJECT_ERASER, config: FJObjectEraseConfig },
    { urlKey: 'image-background-remover', type: FJAppConstant.PHOTO_REMOVE_BG, config: FJPhotoRemoveBgConfig },
    { urlKey: 'video-generator', type: FJAppConstant.AI_VIDEO_GENERATOR, config: FJAIVideoGeneratorConfig },
    { urlKey: 'music-generator', type: FJAppConstant.AI_AUDIO_GENERATOR, config: FJAIAudioConfig },
    { urlKey: 'video-background-remover', type: FJAppConstant.VIDEO_REMOVE_BG, config: FJVideoRemoveBgConfig },
    { urlKey: 'video-to-ai-sfx-generator', type: FJAppConstant.AI_VIDEO_DUB, config: FJAiVideoDubConfig },
    { urlKey: 'ai-text-based-editing', type: FJAppConstant.AI_TEXT_BASED_EDITING, config: FJTextBasedEditingConfig },
    { urlKey: 'text-to-full-video', type: FJAppConstant.TEXT_TO_FULL_VIDEO, config: FJTextToVideoConfig },
    { urlKey: 'blog-url-to-video', type: FJAppConstant.BLOG_URL_TO_VIDEO, config: FJTextToVideoConfig },
    { urlKey: 'product-url-to-ads', type: FJAppConstant.PRODUCT_URL_TO_VIDEO, config: FJTextToVideoConfig },
    { urlKey: 'ppt-to-video', type: FJAppConstant.PPT_TO_VIDEO, config: FJTextToVideoConfig },
];

class FJAppConfigManager {
    constructor() {
        this._configList = [];
    }

    // 初始化配置列表
    init = () => {
        FJAppConfigList.forEach(data => {
            const { urlKey, type, config } = data;
            const appConfig = new FJAppConfig({ urlKey, type, config });
            this._configList.push(appConfig);
        });
    };

    // 获取默认类型
    getDefaultType = () => {
        let appType = currentProjectType || FJAppConstant.IMAGE_TO_IMAGE;
        const localPath = window.location.pathname;
        const keys = localPath.split('/');
        for (let i = 0; i < keys.length; i++) {
            const value = keys[i];
            if (value) {
                const type = this.convertUrlKeyToType(value);
                if (type) {
                    appType = type;
                    break;
                }
            }
        }
        return appType;
    };

    // 合并配置
    mergeConfig(config, appType) {
        if (!config) return;
        const appConfig = this.getConfig(appType);
        if (appConfig) {
            Object.assign(config, appConfig);
        }
    }

    // 获取app的config
    getConfig = (appType = '', urlKey = '') => {
        const data = this._getAppConfigData(appType, urlKey);
        return data ? data.config : undefined;
    };

    // 将urlKey转换成appType
    convertUrlKeyToType = (urlKey = '') => {
        const data = this._getAppConfigData(undefined, urlKey);
        return data ? data.type : undefined;
    };

    // 将appType转换成urlKey
    convertTypeToUrlKey = (appType = '') => {
        const data = this._getAppConfigData(appType);
        return data ? data.urlKey : undefined;
    };

    // 获取appConfig对象
    _getAppConfigData = (appType = '', urlKey = '') => {
        return this._configList.find(config => config.type === appType || config.urlKey === urlKey);
    };
}

const appConfigManager = new FJAppConfigManager();
export default appConfigManager;
